/**
 * Theme color utilities for consistent color handling across widgets.
 * Maps semantic color names to CSS custom properties.
 */

/**
 * Named theme colors that map to Tailwind color classes.
 * These colors have corresponding CSS custom properties defined (e.g., --sky-500).
 *
 * TODO: Consider sourcing this from the DB enum (public.theme_color) to have one source of truth.
 */
export const THEME_COLOR_NAMES = [
  'amber',
  'green',
  'indigo',
  'neutral',
  'orange',
  'pink',
  'purple',
  'red',
  'sky',
  'teal',
] as const;

export type ThemeColorName = (typeof THEME_COLOR_NAMES)[number];

/**
 * Maps a theme color name to its CSS custom property value.
 * @param color - The theme color name (e.g., 'sky', 'pink'). Use ThemeColorName for type safety.
 * @param shade - The color shade (50, 100, 200, etc.). Defaults to 500.
 * @returns A CSS var() reference to the color
 *
 * @example
 * getTailwindColorValue('sky') // returns 'var(--sky-500)'
 * getTailwindColorValue('sky', 700) // returns 'var(--sky-700)'
 */
export function getTailwindColorValue(color: ThemeColorName | string, shade: number = 500): string {
  return `var(--${color}-${shade})`;
}
